module.exports = __webpack_public_path__ + "img/browsers.6b95a2e1.png";